import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { Color, InvaderService } from './invader.service'

export class Card {
  disabled: boolean = false
  cols: number = 1
  rows: number = 1
  x: number = 0
  y: number = 0

  constructor(
    public id: number,
    public value: Array<Color | number>,
    public selected = false,
    public standalone = false) {
  }

  private _unique: number = 0

  get unique(): number {
    return this._unique
  }

  set unique(unique: number) {
    this._unique = unique
  }

  active() {
    this.disabled = false
  }

  select() {
    this.selected = true
  }

  deselect() {
    this.selected = false
  }

  toggle() {
    this.selected = !this.selected
  }

  complete() {
    this.selected = false
    this.disabled = true
  }
}

export interface Size {
  cols: number
  rows: number
}

export type CardBack = 'star' | 'diamond' | 'moon'
export type CellType = 'word' | 'number' | 'invader'

interface OriginTwin {
  origin: Card
  twin: Card
}

@Injectable({
  providedIn: 'root'
})
export class CardService {

  completed$ = new Subject<void>();

  constructor(private invader: InvaderService) {
  }

  generateCells(
    columns: number,
    rows: number,
    prepare: boolean = false): Card[] {
    const size = columns * rows
    if (size % 2) {
      return []
    } else {
      const pairs = new Array(size / 2)
        .fill(0)
        .map((_, id) => {
          const value = this.invader.generate()
          const origin = new Card(id, value, prepare)
          const twin = new Card(id, value, prepare)
          return {
            origin,
            twin
          }
        })
      return this.shuffleCards(pairs)
    }
  }

  shuffleCards(pairs: OriginTwin[]): Card[] {
    const result: Card[] = []

    pairs.forEach(({ origin, twin }) => {
      result.push(origin)
      result.push(twin)
    })

    return result
      .sort(() => Math.random() - 0.5)
      .sort(() => Math.random() - 0.5)
      .map((cell, index) => {
        cell.unique = index + 1
        return cell
      })
  }

  complete() {
    this.completed$.next();
  }
}
